import { useQuery } from 'react-query';
import { useApiGetNonAuthorized } from './useApi';
import { TenantInfo } from 'utils/types/tenantType';

export const useLoginInfo = (name: string) => {
  const fetchTenantInfo = useApiGetNonAuthorized(`/tenant/public/${name}`);

  return useQuery<TenantInfo>(['loginInfo', name], fetchTenantInfo);
};
